/* Hauly — behaviour for the custom sections (gallery, testimonials, counters, sticky add to cart). */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery(root) {
    if (root.dataset.hlyReady) return;
    root.dataset.hlyReady = '1';
    var track = root.querySelector('[data-hly-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hly-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hly-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hly-dot]'));
    var thumbsWrap = root.querySelector('[data-hly-thumbs]');
    if (!track || !slides.length) return;
    var current = 0;

    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      if (i === current && thumbs[i] && thumbs[i].classList.contains('is-active')) return;
      current = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      var t = thumbs[i];
      if (t && thumbsWrap) {
        var left = t.offsetLeft - thumbsWrap.offsetLeft;
        if (left < thumbsWrap.scrollLeft || left + t.offsetWidth > thumbsWrap.scrollLeft + thumbsWrap.clientWidth) {
          thumbsWrap.scrollTo({ left: left - 8, behavior: 'smooth' });
        }
      }
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        mark(Math.max(0, Math.min(slides.length - 1, i)));
      });
    }, { passive: true });
    var prev = root.querySelector('[data-hly-prev]');
    var next = root.querySelector('[data-hly-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    mark(0);
  }

  /* ---------------- Testimonials carousel (looping) ---------------- */
  function initTestimonials(root) {
    if (root.dataset.hlyReady) return;
    root.dataset.hlyReady = '1';
    var track = root.querySelector('[data-hly-ttrack]');
    var bar = root.querySelector('[data-hly-tbar]');
    if (!track) return;
    var originals = Array.prototype.slice.call(track.children);
    var count = originals.length;
    if (!count) return;
    // Two extra copies on each side make the loop seamless.
    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    for (var k = 0; k < 2; k++) {
      originals.forEach(function (el) {
        var a = el.cloneNode(true); a.setAttribute('aria-hidden', 'true'); a.dataset.hlyClone = '1';
        var b = el.cloneNode(true); b.setAttribute('aria-hidden', 'true'); b.dataset.hlyClone = '1';
        before.appendChild(a);
        after.appendChild(b);
      });
    }
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    function step() {
      var c = track.children;
      return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : track.clientWidth;
    }
    function setWidth() { return step() * count; }
    function jumpTo(x) {
      var prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = x;
      requestAnimationFrame(function () { track.style.scrollSnapType = prevSnap; });
    }
    function home() { jumpTo(setWidth() * 2); }
    home();
    window.addEventListener('resize', home);

    var settle;
    function normalise() {
      var w = setWidth();
      if (track.scrollLeft < w * 1) jumpTo(track.scrollLeft + w);
      else if (track.scrollLeft >= w * 3) jumpTo(track.scrollLeft - w);
    }
    function progress() {
      if (!bar) return;
      var w = setWidth();
      var pos = ((track.scrollLeft % w) + w) % w;
      var wPct = Math.max(12, Math.min(100, (track.clientWidth / w) * 100 / 2));
      bar.style.width = wPct + '%';
      bar.style.left = (pos / w) * (100 - wPct) + '%';
    }
    track.addEventListener('scroll', function () {
      progress();
      clearTimeout(settle);
      settle = setTimeout(normalise, 140);
    }, { passive: true });
    progress();

    function move(dir) {
      normalise();
      track.style.scrollBehavior = 'smooth';
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-hly-tprev]');
    var next = root.querySelector('[data-hly-tnext]');
    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
  }

  /* ---------------- Count-up numbers ---------------- */
  function initCounters(root) {
    var nums = root.querySelectorAll('[data-hly-count]');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var target = parseInt(el.dataset.hlyCount, 10) || 0;
        var suffix = el.dataset.hlySuffix || '';
        var start = null;
        var dur = 1200; setTimeout(function () { el.textContent = target + suffix; }, 1600);
        function frame(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.3 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------------- Sticky add to cart ---------------- */
  function initSticky(root) {
    if (root.dataset.hlyStickyReady) return;
    root.dataset.hlyStickyReady = '1';
    var sticky = root.querySelector('[data-hly-sticky]');
    if (!sticky) return;
    // Move to <body> so no ancestor's transform/overflow can clip it.
    document.body.appendChild(sticky);
    var dismissed = false;
    function mainButton() { return root.querySelector('.hly-buy .add-to-cart-button, .hly-buy button[name="add"], .hly-buy [type="submit"]'); }
    var target = root.querySelector('.hly-buy') || root;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', passed && !dismissed);
        });
      });
      io.observe(target);
    }
    var btn = sticky.querySelector('[data-hly-sticky-add]');
    if (btn) btn.addEventListener('click', function () {
      var b = mainButton();
      if (b) b.click();
      else target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    var close = sticky.querySelector('[data-hly-sticky-close]');
    if (close) close.addEventListener('click', function () { dismissed = true; sticky.classList.remove('is-visible'); });

    var select = sticky.querySelector('[data-hly-sticky-variant]');
    if (select) select.addEventListener('change', function () {
      var id = select.value;
      root.querySelectorAll('.hly-buy input[name="id"]').forEach(function (i) { i.value = id; });
      var opt = select.options[select.selectedIndex];
      var price = sticky.querySelector('[data-hly-sticky-price]');
      var was = sticky.querySelector('[data-hly-sticky-was]');
      if (price && opt) price.textContent = opt.dataset.price || price.textContent;
      if (was && opt) { was.textContent = opt.dataset.compare || ''; was.hidden = !opt.dataset.compare; }
      // Keep the Kaching colour picker (first bundle bar) in step when it exists.
      var kSelect = document.querySelector('.kaching-bundles__bar--selected select, .kaching-bundles select');
      if (kSelect && opt) {
        var label = opt.textContent.trim();
        Array.prototype.forEach.call(kSelect.options, function (o) {
          if (o.value === id || o.textContent.trim() === label) { kSelect.value = o.value; }
        });
        kSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-hly-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-hly-testimonials]').forEach(initTestimonials);
    scope.querySelectorAll('[data-hly-counters]').forEach(initCounters);
    scope.querySelectorAll('[data-hly-main]').forEach(initSticky);
  }

  ready(function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
